export default __webpack_public_path__ + "static/recipes-02-img-8e4956a5176951a559b0e61bf59bd891.png";